import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {Injectable} from "@angular/core";
import {LOCAL_STOAGE_KEYS} from "../const/localstorage.const";

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.getLanguage();

    const clonedRequest = request.clone({
      setHeaders: {
        'Accept-Language': language
      }
    });

    return next.handle(clonedRequest);
  }

  private getLanguage(): string {
    return localStorage.getItem(LOCAL_STOAGE_KEYS.LOCAL_STORAGE_LANGUAGE) || 'it';
  }
}
